import { CONTACT_EMAIL, BUSINESS_NAME, PRICE } from '../data/content';
const blocks = [{
  title: 'Qué estás comprando',
  body: `Material educativo digital sobre carpintería en aluminio. El Super Combo (${PRICE.combo} ARS) incluye 6 tomos y 6 recursos complementarios en formato digital. El Super Combo PRO (${PRICE.pro} ARS) incluye todo lo anterior más Master-Calc & Diseño PRO y Master-Guide Muebles & Diseño en Aluminio. No se envía ningún producto físico. Ambas versiones son de pago único, sin suscripciones ni cobros recurrentes.`
}, {
  title: 'Privacidad',
  body: 'Los datos ingresados en el checkout se utilizan únicamente para procesar la compra y entregar el material adquirido. No se comparten con terceros ajenos al procesamiento del pago ni se utilizan para fines distintos a los informados.'
}, {
  title: 'Términos y condiciones',
  body: 'El acceso al material es personal e intransferible. Queda prohibida su reventa, copia o distribución total o parcial. El contenido tiene fines educativos y de capacitación en el oficio de carpintería en aluminio. Al realizar la compra, el usuario acepta estos términos junto con la política de privacidad.'
}];
export function LegalFooter() {
  return <footer className="border-t border-crudo/10 bg-noche px-5 py-10 sm:px-8" data-id="element-92" data-mp="2bih7ltlndl8j">
      <div className="mx-auto max-w-4xl" data-id="element-93" data-mp="2gj50kktfsc5e">
        <p className="font-display text-sm font-extrabold uppercase tracking-wider text-crudo" data-id="element-94" data-mp="2gjwvruj4g7v5">
          {BUSINESS_NAME}
        </p>

        <div className="mt-6 grid gap-6 sm:grid-cols-3" data-id="element-95" data-mp="2pja5mob5qyge">
          {blocks.map(block => <section key={block.title} data-id="element-96" data-mp="2ua0b01jl31b3">
              <h2 className="font-display text-[0.7rem] font-extrabold uppercase tracking-wider text-electrico-light" data-id="element-97" data-mp="2ub1p6evwc3x1">
                {block.title}
              </h2>
              <p className="mt-2 text-[0.7rem] leading-relaxed text-aluminio/50" data-id="element-98" data-mp="348g58ddwqqot">
                {block.body}
              </p>
            </section>)}
        </div>

        <div className="mt-8 border-t border-crudo/10 pt-6" data-id="element-99" data-mp="387f5hkop1z9x">
          <p className="text-[0.7rem] leading-relaxed text-aluminio/40" data-id="element-100" data-mp="195t7owyz80dm">
            Contacto:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-aluminio/70 underline underline-offset-2 hover:text-crudo" data-id="element-101" data-mp="14782ej4vaqib">
              {CONTACT_EMAIL}
            </a>
          </p>
          <p className="mt-3 text-[0.7rem] leading-relaxed text-aluminio/40" data-id="element-102" data-mp="1d4igec92ktqx">
            Aviso: el contenido es material educativo y de capacitación. Los
            resultados dependen de la dedicación, la práctica y las condiciones
            de cada persona. No se garantizan ingresos, ganancias ni resultados
            económicos concretos.
          </p>
        </div>
      </div>
    </footer>;
}